import { Component, DestroyRef, Inject, ViewChild, inject, ElementRef, Input } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ServicesService } from 'src/services/services.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { finalize } from 'rxjs/operators';

export interface CategoryData {
  category_id: any;
  so_id: any;
  event_id: any;
}

export interface ElementData {
  category_id: string;
  srNo: string;
  category: string;
  action: any;
}

@Component({
  selector: 'app-stall-category',
  templateUrl: './stall-category.component.html',
  styleUrls: ['./stall-category.component.scss']
})
export class StallCategoryComponent {
  @ViewChild('input') input!: ElementRef<HTMLInputElement>;
  @Input() so_id: any;

  displayedColumns: string[] = [
    'srNo',
    'category',
    'action',
  ];

  ELEMENT_DATA: ElementData[] = [];
  event_result: any;
  category_id: any;

  private destoryRef = inject(DestroyRef);

  dataSource = new MatTableDataSource<ElementData>();

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  event_id: any;

  constructor(private service: ServicesService,
    private router: Router,
    private toastr: ToastrService,
    private dialog: MatDialog,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
  ) { }

  ngAfterViewInit() {
    // Get so_id from URL
    if (!this.so_id) {
      this.so_id = this.route.snapshot.paramMap.get('so_id');
    }
    console.log(this.so_id);
    this.get_category(this.so_id);
    this.dataSource.paginator = this.paginator;
  }

  AddScanningPoint() {
    const dialogRef = this.dialog.open(add_edit_category, {
      data: {
        category_id: this.category_id,
        so_id: this.so_id,
        event_id: this.event_id
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      this.get_category(this.so_id);
    });
  }

  EditScanningPoint(category_id: any) {
    const dialogRef = this.dialog.open(add_edit_category, {
      data: {
        category_id: category_id,
        so_id: this.so_id,
        event_id: this.event_id
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.get_category(this.so_id);
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  get_category(so_id: any) {
    this.ELEMENT_DATA = [];
    this.spinner.show();
    this.service.get_category(so_id).pipe(takeUntilDestroyed(this.destoryRef), finalize(() => this.spinner.hide())).subscribe(
      (data: any) => {
        this.event_id = data.event_id;
        this.event_result = data.data;
        this.ELEMENT_DATA = this.event_result.map((item: { category_id: any; category: any; }, index: number) => ({
          srNo: index + 1,
          category_id: item.category_id,
          category: item.category,
          action: item.category_id
        })
        );
        this.spinner.hide();
        this.dataSource = new MatTableDataSource<ElementData>(this.ELEMENT_DATA);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    );
  }

  DeleteCategory(category_id: any) {
    const buttonClicked = window.confirm('Are You Sure To Delete This Category?');
    if (buttonClicked === true) {
      this.service.delete_category(category_id).pipe(takeUntilDestroyed(this.destoryRef)).subscribe(
        data => {
          this.ELEMENT_DATA = this.ELEMENT_DATA.filter(item => item.category_id !== category_id);
          this.dataSource.data = this.ELEMENT_DATA;
          this.toastr.success("Category Deleted Succesfully");
        });
    }
  }
}



@Component({
  selector: 'add_edit_category',
  templateUrl: './add_edit_category.html',
  styleUrls: ['./stall-category.component.scss'],
  standalone: false
})
export class add_edit_category {

  CategoryForm: FormGroup;
  category_id: any
  result: any;
  hide = true;
  private destoryRef = inject(DestroyRef);
  point_data: any;
  event_id: any;
  category: any;
  so_id: any;

  constructor(
    private member: FormBuilder,
    private service: ServicesService,
    private dialogRef: MatDialogRef<add_edit_category>,
    private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: CategoryData
  ) {
    this.category_id = data['category_id'];
    this.so_id = data['so_id'];
    this.event_id = data['event_id'];
    this.CategoryForm = this.member.group({
      category_id: this.category_id,
      so_id: this.so_id,
      category: new FormControl('', [Validators.required, Validators.pattern(/^(\s*\S+\s*)+$/),]),
    });
  }

  ngOnInit(): void {
    this.Get_Category_By_Id(this.category_id)
  }

  Get_Category_By_Id(category_id: any) {
    this.service.get_category_by_id(category_id).subscribe(
      (data: any) => {
        this.point_data = data.data;
        this.category = this.point_data[0].category;
      });
  }

  onFormSubmit() {
    console.log(this.CategoryForm.value);
    const formData = this.CategoryForm.value;
    const hasNonEmptyField = Object.values(formData).some(value => value !== null && value !== '');
    if (this.CategoryForm.valid && hasNonEmptyField) {

      if (this.category_id) {
        this.service.edit_category(this.CategoryForm.value).pipe(takeUntilDestroyed(this.destoryRef)).subscribe({
          next: (val: any) => {
            this.toastr.success("Category Updated Succesfully");
            this.dialogRef.close(true);
          },
          error: (err: any) => {
            console.error(err);
          },
        });
      } else {
        this.service.add_category(this.CategoryForm.value).pipe(takeUntilDestroyed(this.destoryRef)).subscribe({

          next: (val: any) => {
            this.toastr.success("Category Added Succesfully");
            this.dialogRef.close(true);
          },
          error: (err: any) => {
            console.error(err);
          },
        });
      }
    } else {
      this.toastr.error("Please Fill Required Fields")
    }
  }
}